module.exports = __webpack_public_path__ + "media/images/allow_right_white-b3d3bc4a283f3c105004283da8be6dc0.svg";